import React from 'react';
import {Drawer, DrawerHeaderProps} from '@mantine/core';

export const EtroDrawerHeader: React.FC<DrawerHeaderProps> = props => {
  return <Drawer.Header {...props} />;
};
